import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_DOCTOR_LISTING,
    GET_DOCTOR_DETAILS,
    UPDATE_DOCTOR,
    DOCTOR_ACTIVATION,
    GET_DOCTOR_HISTORY_LISTING,
    EXPORT_DOCTOR_LISTING,
    GET_DOCTOR_ORDERS,
    GET_DOCTOR_COMMISSION,
    GET_DOCTOR_COMMISSION_BREAKDOWN,
    ADD_DOCTOR,
    DELETE_DOCTOR,
} from "./actionTypes.js";

import {
    getDoctorListingSuccess,
    getDoctorListingFail,
    getDoctorDetailsSuccess,
    getDoctorDetailsFail,
    updateDoctorSuccess,
    updateDoctorFail,
    doctorActivationSuccess,
    doctorActivationFail,
    getDoctorHistoryListingSuccess,
    getDoctorHistoryListingFail,
    exportDoctorListingSuccess,
    exportDoctorListingFail,
    getDoctorOrdersSuccess,
    getDoctorOrdersFail,
    getDoctorCommissionSuccess,
    getDoctorCommissionFail,
    getDoctorCommissionBreakdownSuccess,
    getDoctorCommissionBreakdownFail,
    addDoctorSuccess,
    addDoctorFail,
    deleteDoctorSuccess,
    deleteDoctorFail,
} from "./actions.js";

import {
    doctorListingApi,
    doctorActivationApi,
    exportDoctorListingApi,
    getDoctorDetailsApi,
    editDoctorApi,
    getDoctorHistoryListingApi,
    getDoctorOrdersApi,
    getDoctorCommissionsApi,
    getDoctorCommissionsBreakdownApi,
    createDoctorApi,
    deleteDoctorApi,
} from "./doctorApi.js";

function* fetchDoctorListing({ payload }) {
    try {
        const response = yield call(doctorListingApi, payload);
        yield put(getDoctorListingSuccess(response));
    } catch (error) {
        yield put(getDoctorListingFail(error));
    }
}

function* fetchDoctorDetails({ payload }) {
    try {
        const response = yield call(getDoctorDetailsApi, payload);
        yield put(getDoctorDetailsSuccess(response));
    } catch (error) {
        yield put(getDoctorDetailsFail(error));
    }
}

function* addDoctor({ payload }) {
    try {
        const response = yield call(createDoctorApi, payload);
        yield put(addDoctorSuccess(response));
    } catch (error) {
        yield put(addDoctorFail(error));
    }
}

function* updateDoctor({ payload }) {
    try {
        const response = yield call(editDoctorApi, payload);
        yield put(updateDoctorSuccess(response));
    } catch (error) {
        yield put(updateDoctorFail(error));
    }
}

function* deleteDoctor({ payload }) {
    try {
        const response = yield call(deleteDoctorApi, payload);
        yield put(deleteDoctorSuccess(response));
    } catch (error) {
        yield put(deleteDoctorFail(error));
    }
}

function* activateDoctor({ payload }) {
    try {
        const response = yield call(doctorActivationApi, payload);
        yield put(doctorActivationSuccess(response));
    } catch (error) {
        yield put(doctorActivationFail(error));
    }
}

function* fetchDoctorHistoryListing({ payload }) {
    try {
        const response = yield call(getDoctorHistoryListingApi, payload);
        yield put(getDoctorHistoryListingSuccess(response));
    } catch (error) {
        yield put(getDoctorHistoryListingFail(error));
    }
}

function* exportDoctorListing({ payload }) {
    try {
        const response = yield call(exportDoctorListingApi, payload);
        yield put(exportDoctorListingSuccess(response));
    } catch (error) {
        yield put(exportDoctorListingFail(error));
    }
}

function* fetchDoctorOrders({ payload }) {
    try {
        const response = yield call(getDoctorOrdersApi, payload);
        yield put(getDoctorOrdersSuccess(response));
    } catch (error) {
        yield put(getDoctorOrdersFail(error));
    }
}

function* fetchDoctorCommission({ payload }) {
    try {
        const response = yield call(getDoctorCommissionsApi, payload);
        yield put(getDoctorCommissionSuccess(response));
    } catch (error) {
        yield put(getDoctorCommissionFail(error));
    }
}

function* fetchDoctorCommissionBreakdown({ payload }) {
    try {
        const response = yield call(getDoctorCommissionsBreakdownApi, payload);
        yield put(getDoctorCommissionBreakdownSuccess(response));
    } catch (error) {
        yield put(getDoctorCommissionBreakdownFail(error));
    }
}

function* DoctorSaga() {
    yield takeEvery(GET_DOCTOR_LISTING, fetchDoctorListing);
    yield takeEvery(GET_DOCTOR_DETAILS, fetchDoctorDetails);
    yield takeEvery(ADD_DOCTOR, addDoctor);
    yield takeEvery(UPDATE_DOCTOR, updateDoctor);
    yield takeEvery(DELETE_DOCTOR, deleteDoctor);
    yield takeEvery(DOCTOR_ACTIVATION, activateDoctor);
    yield takeEvery(GET_DOCTOR_HISTORY_LISTING, fetchDoctorHistoryListing);
    yield takeEvery(EXPORT_DOCTOR_LISTING, exportDoctorListing);
    yield takeEvery(GET_DOCTOR_ORDERS, fetchDoctorOrders);
    yield takeEvery(GET_DOCTOR_COMMISSION, fetchDoctorCommission);
    yield takeEvery(GET_DOCTOR_COMMISSION_BREAKDOWN, fetchDoctorCommissionBreakdown);
}

export default DoctorSaga;